module.exports = __webpack_public_path__ + "img/ewm3.c0e6ec46.png";